import React, { useState, useEffect } from 'react';
import { Container, Typography, Grid, Button } from '@mui/material';
import axios from 'axios';

const fetchDescriptionsFromGPT = async (word, learnedWords) => {
  const apiKey = 'sk-proj-R8ckuOJvBGOO7ZOFsF2kT3BlbkFJ2RtkJrlmX1tXU7OFyBAD';
  const url = 'https://api.openai.com/v1/chat/completions';

  try {
    const response = await axios.post(
      url,
      {
        model: 'gpt-3.5-turbo',
        messages: [
          { role: 'system', content: 'You are a language assistant.' },
          {
            role: 'user',
            content: `The word is "${word}". Provide one correct description in Arabic followed by three incorrect descriptions. description should have 5 words. Separate each description with a comma, and do not include any labels, numbers, or additional text. Make sure the last description does not end with a comma. The response should be formatted exactly like this: correct description, incorrect description 1, incorrect description 2, incorrect description 3.`
            // content: `The word is "${word}". Provide a simple, clear description in Arabic for this word but do not say it. Additionally, provide three incorrect descriptions related to this word.`,
          },
        ],
        max_tokens: 150,
        n: 1,
        stop: null,
        temperature: 0.7,
      },
      {
        headers: {
          'Authorization': `Bearer ${apiKey}`,
          'Content-Type': 'application/json',
        },
      }
    );

    // const description = response.data.choices[0].message.content.trim().split(',').map(item => item.trim());;

    // const [correctDescription, ...wrongDescriptions] = description.split('\n').map(desc => desc.trim());

    const description = response.data.choices[0].message.content.trim().split(',').map(item => item.trim());
const [correctDescription, ...wrongDescriptions] = description;

    
    return { correctDescription, wrongDescriptions };
  } catch (error) {
    console.error('Error fetching descriptions from GPT:', error.response ? error.response.data : error.message);
    return {
      correctDescription: 'شيء يأكله الناس',
      wrongDescriptions: ['شيء يكتب به الناس', 'مكان للجلوس', 'أداة للعب'],
    }; // Default descriptions if API call fails
  }
};


const ImageSelection = ({ word, onNext }) => {
  const [descriptions, setDescriptions] = useState([]);
  const [correctDescription, setCorrectDescription] = useState('');

  useEffect(() => {
    const fetchDescriptions = async () => {
      const { correctDescription, wrongDescriptions } = await fetchDescriptionsFromGPT(word);
      setCorrectDescription(correctDescription);
      setDescriptions([...wrongDescriptions, correctDescription].sort(() => Math.random() - 0.5));
    };

    fetchDescriptions();
  }, [word]);

  const handleSelection = (selectedDescription) => {
    if (selectedDescription === correctDescription) {
      onNext();  // Proceed to the next step if the answer is correct
    } else {
      alert('خطأ حاول مره أخرى');  // Alert if the answer is incorrect
    }
  };

  console.log(descriptions);
  

  return (
    <Container maxWidth="sm" style={{ marginTop: '20px', textAlign: 'center' }}>
      <Typography variant="h5" gutterBottom>
        اختر الوصف الصحيح للكلمة "{word}"
      </Typography>
      <Grid container spacing={2}>
        {descriptions.map((description, index) => (
          <Grid item xs={12} key={index}>
            <Button variant="outlined" fullWidth onClick={() => handleSelection(description)}>
              {description}
            </Button>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ImageSelection;
